import React, { useState } from "react";
import PortafolioDevicesList from "./PortafolioDevicesList";
import LoadSimple from "../LoadSimple";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
const TablePortafolioDevices = ({
  pageActual,
  limitList,startLimit,
  devices,
  dataList,
  cisSelected,
  setServiceSelected,
  ServiceSelected,
  registerIsValid,
  searchResults,
  setSearchResults,
  onSearch,
  dataUsers,
  setDataUsers,
  searchTerm,
  setSearchTerm,
  server,
  setRegisterIsValid,
  setData,
  setLoading,
  setError,
  handleChangEdit,
  dataService,
  setDataService,
  sla,
  setSla,
  dataObject,
  setDataObject,
  dataCisConf,
  tecSelected,
       setTecSelected,
       slaService,
         setSlaService,
         slaTech,
         setSlaTech,
         languaje,mode,handleShowPopup
}) => {
  return (
    <div className="cont-table-portafolio">
      <div className="head-table-portafolio">
        <div className="compact-head-table-portafolio">
        <div className="field-head-table-portafolio field-small">ID</div>
        <div className="field-head-table-portafolio field-medium">Host ID</div>
        <div className="field-head-table-portafolio field-larger">IP</div>
        <div className="field-head-table-portafolio field-larger" style={{width:'40%'}}>HostName</div>
        <div className="field-head-table-portafolio field-larger" style={{width:'25%'}}>{capitalizeFirstLetter(lang[languaje]['ubicacion'])}</div>
        
        
        <div className="field-head-table-portafolio field-medium">SLA</div>
        <div className="field-head-table-portafolio field-medium">{capitalizeFirstLetter(lang[languaje]['severidad'])}</div>
         
        
        <div className="field-head-table-portafolio field-medium">Status</div> 
        <div className="field-head-table-portafolio field-larger">{capitalizeFirstLetter(lang[languaje]['acciones'])}</div>
        </div>
        
      </div>
      <div className="body-table-portafolio">
        {registerIsValid ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          <PortafolioDevicesList
          setDataService={setDataService}
      dataService={dataService}
            pageActual={pageActual}
             limitList={limitList} startLimit={startLimit}
            dataList={dataList}
            devices={devices}
            cisSelected={cisSelected}
            setServiceSelected={setServiceSelected}
            ServiceSelected={ServiceSelected}
            searchResults={searchResults}
            setSearchResults={setSearchResults}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            dataUsers={dataUsers}
            setDataUsers={setDataUsers}
            server={server}
            setRegisterIsValid={setRegisterIsValid}
            setData={setData}
            setLoading={setLoading}
            setError={setError}
            handleChangEdit={handleChangEdit}
            sla={sla}
                      setSla={setSla}
                      dataObject={dataObject}
                      setDataObject={setDataObject}
                      tecSelected={tecSelected}
       setTecSelected={setTecSelected}
       
       slaService={slaService}
         setSlaService={setSlaService}
         slaTech={slaTech}
         setSlaTech={setSlaTech}
                      dataCisConf={dataCisConf}
                      languaje={languaje}
                      mode={mode}
                      handleShowPopup={handleShowPopup}
          ></PortafolioDevicesList>
        )}
      </div>
    </div>
  );
};

export default TablePortafolioDevices;
